import { POSTAG } from './lib/postag/ids';

export { POSTAG }

export default POSTAG
